// @ts-nocheck
import axios from 'axios'
import { getToken } from '@/js/auth.js'
import router from '@/router'
import store from '@/store/store'
import utils from '@/js/util'

const debug = process.env.NODE_ENV !== 'production'
const axoiosInstance = axios.create({
  baseURL: debug ? 'api' : 'http://1.3.4.5.6:89',
  // @ts-ignore
  crossDomain: true,

  headers: {
    // "X-Requested-With": "XMLHttpRequest",
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS, DELETE',
    // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, token',
    // 'Access-Control-Allow-Credentials': true,
    // 'Content-Type': 'application/json;charset=UTF-8',
    // 'Accept': 'text/xml; charset=utf-8',
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  withCredentials: true
})

// "X-Requested-With": "XMLHttpRequest"
// http request interceptor
axoiosInstance.interceptors.request.use(
  config => {
    config.headers.token = getToken()
    if (localStorage.getItem('userInfo')) {
      config.headers.userInfo = localStorage.getItem('userInfo')
    }
    if (localStorage.getItem('JSESSIONID')) {
      config.headers.JSESSIONID = localStorage.getItem('JSESSIONID')
    }
    return config
  },
  error => Promise.reject(error)
)

// http response 拦截器
axoiosInstance.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      router.push({
        path: '/login',
        querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      })
    } else if (response.data.code == 'A0007') {
      router.push({
        path: '/login',
        querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      })
      utils.error(response.data.msg)
      store.commit('logout')
    } else if (response.data.code == 'A0006') {
      router.push({
        path: '/login',
        querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      })
      store.commit('logout')
    }
    return response
  },
  error => {
    // 获取状态码
    if (!error || !error.response) {
      utils.error('网络连接失败！')
      return
    }
    const { status } = error.response

    if (status === 401) {
      // 清除token
      store.commit('logout')
      // 重新登录
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// http request
const $axios = function (url, method, params, defaultUrl) {
  if (defaultUrl === true) {
    url = `${gisserverUrl}` + url
  } else {
    url = `${gisserverUrl}` + url
  }

  return new Promise((resolve, reject) => {
    axoiosInstance[method](url, params || {})
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        }
      })
      .catch(error => {
        reject(error) // 注释掉后不知道会造成怎样的影响，但是去掉了浏览器打印的错误
      })
  })
}
export default $axios

export { axoiosInstance }
